module.exports = __webpack_public_path__ + "assets/b51.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b51.png
// module id = 640
// module chunks = 0